<template>
    <div class="studi-instructions-form">
        <b-form data-vv-scope="petunjuk-form">
            <b-form-group>
                <b-form-radio-group
                    id="tes"
                    name="tes"
                    v-model="silabus_form.is_file"
                    :options="options"
                    class="mb-3"
                    value-field="item"
                    text-field="name"
                ></b-form-radio-group>
                <span :class="{ 'error-validation': errors.first('petunjuk-form.is_file') }">{{ errors.first('petunjuk-form.is_file') }}</span>
            </b-form-group>
            <b-form-group>
                <b-form-radio-group
                    v-if="silabus_form.is_file==1"
                    id="fileType"
                    name="fileType"
                    v-model="silabus_form.file_type"
                    :options="option_types"
                    class="mb-3"
                    value-field="item"
                    text-field="name"
                    v-validate="'required'"
                ></b-form-radio-group>
                <span :class="{ 'error-validation': errors.first('petunjuk-form.file_type') }">{{ errors.first('petunjuk-form.file_type') }}</span>
            </b-form-group>
            <b-form-group
                v-if="silabus_form.is_file==1"
                id="link"
                label="Link"
            >
                <b-form-input v-model="silabus_form.file_path" v-validate="'required'"></b-form-input>
                <span :class="{ 'error-validation': errors.first('petunjuk-form.file_path') }">{{ errors.first('petunjuk-form.file_path') }}</span>
            </b-form-group>
            <b-form-group>
                <wysiwyg v-if="silabus_form.is_file==0"
                    id="petunjuk"
                    name="petunjuk"
                    data-vv-as="Petunjuk"
                    v-model="silabus_form.description"
                    type="text"
                    v-validate="'required'"
                    autocomplete="off"
                />
                <span :class="{ 'error-validation': errors.first('petunjuk-form.petunjuk') }">{{ errors.first('petunjuk-form.petunjuk') }}</span>
            </b-form-group>
        </b-form>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideStudiInstructionsFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" :disabled="isDisabled()" @click.prevent="saveSilabus">SIMPAN</b-button>
        </div>
    </div>
</template>
<script>
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            subjectId: {
                type: String,
                default: null
            },
            silabusId: {
                type: String,
                default: null
            },
            attributes: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                silabus_form: {
                    id: this.silabusId,
                    subjects_id: this.subjectId,
                    description: this.attributes.description,
                    is_file: this.attributes.is_file,
                    file_type: this.attributes.file_type,
                    file_path: this.attributes.file_path
                },
                options: [
                    { item: '1', name: 'Link' },
                    { item: '0', name: 'Text' },
                ],
                option_types: [
                    { item: 'pdf', name: 'Google Drive' },
                    { item: 'video', name: 'Youtube' },
                ]
            }
        },
        methods: {
            isDisabled() {
                let scope = 'petunjuk-form';
                // evaluate whatever you need to determine disabled here...
                return scope.validated;
            },
            hideStudiInstructionsFormModal() {
                EventBus.$emit('hideStudiInstructionsFormModal', true)
                this.resetStudiInstructionsForm()
            },
            resetStudiInstructionsForm() {
                this.silabus_form.description = null,
                this.$validator.reset()
            },
            async saveSilabus() {
                let scope = 'petunjuk-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showLoader = true
                        if(this.silabus_form.is_file==1){
                            this.silabus_form.description = '-'
                        }else{
                            this.silabus_form.file_type = 'text'
                            this.silabus_form.file_path = '-'
                        }
                        let form = this.silabus_form
                        this.$store.dispatch('editSilabus', form)
                            .then((res) => {
                                this.showLoader = false
                                let subjectId = this.subjectId
                                this.$store.dispatch('getSilabus', { subjectId })
                                this.hideStudiInstructionsFormModal()
                                this.$swal.fire('Success', res.message, 'success')
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                } else {
                                    this.$swal.fire('Failed', error.data.message, 'error')
                                }
                            })
                    }
                });
            },
        },
        created() {
			EventBus.$on('resetStudiInstructionsForm', (val) => {
				if (val) {
					this.resetStudiInstructionsForm()
				}
			})
        }
    }
</script>